<template>
    <v-row no-gutters class="mb-5">
        <v-col cols="12" sm="12" md="7" lg="7" xl="7" class="bg-primary"
               :class="$vuetify.display.smAndDown?'rounded-t-lg':'rounded-s-lg'">
            <div class="py-5 py-md-10 py-lg-10 py-xl-10 px-6 px-md-12 px-lg-12 px-xl-12">
                <v-row no-gutters>
                    <v-col cols="12" sm="12" md="10" lg="10" xl="10">
                        <div class="pb-5 font-weight-bold custom-lineheight"
                             :class="$vuetify.display.mdAndUp?'text-h3':'custom-mobile-hero-text'" v-html="$t('referrers.signUp_title')">
                        </div>
                        <div class="custom-subtitle font-weight-medium">
                            {{ $t('referrers.signUp_subtitle') }}
                        </div>

                    </v-col>

                </v-row>
                <v-form class="my-5" @submit.prevent="signUpConfirm">
                    <div class="text-h6 font-weight-bold">
                        {{ $t('referrers.signUp_enterDetails') }}
                    </div>
                    <v-row class="mt-3">
                        <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                            <v-text-field v-model="form.full_name" variant="solo" density="comfortable"
                                          :placeholder="$t('referrers.signUp_yourFullName')" :rules="[rules.required]"/>
                        </v-col>
                        <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                            <v-text-field v-model="form.email" variant="solo" density="comfortable" :placeholder="$t('referrers.signUp_email')"
                                          :rules="[rules.required, rules.email]"
                                          :error-messages="errors.email ? [errors.email[0]] : []"
                            />
                        </v-col>
                        <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                            <v-btn type="submit" variant="elevated" size="large" class="font-weight-bold py-6" block
                                   color="success" append-icon="mdi-arrow-right">{{ $t('referrers.signUp_continue') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </div>
        </v-col>
        <v-col cols="12" sm="12" md="5" lg="5" xl="5" class="bg-primary align-center"
               :class="$vuetify.display.smAndDown?'rounded-b-lg':'rounded-e-lg'">
            <v-img aspect-ratio="1" height="100%" cover src="/img/referral/sign-up-photo.webp"
                   class="sign-up__form__rounded-img"></v-img>
        </v-col>
    </v-row>
</template>


<script>
export default {
    name: "SignUpForm",
    components: {
    },
    props: {
        errors: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            form: {
                full_name: '',
                email: '',
            },
            rules: {
                required: value => !!value || this.$t('referrers.Field is required'),
                email: value => !value || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value) || this.$t('referrers.E-mail must be valid'),
            },
        };
    },
    methods: {
        async signUpConfirm(e) {
            e.preventDefault();
            e.stopPropagation();
            let res = await e;
            if (!res.valid) return;
            this.$inertia.post(this.route("referral.sign-up-partner"), this.form);
        }
    },
}
</script>

<style lang="scss">
.sign-up__form__rounded-img {
    border-radius: 100% 8px 8px 100%;
    @media (max-width: 960px) {
        border-radius: 100% 100% 8px 8px;
    }
}

.sign-up__form__span {
    background: #F6C407;
    border-radius: 40px;
    color: #051337;
}

.custom-mobile-hero-text {
    @media (max-width: 959px) {
        font-size: 28px;
    }
}

.custom-lineheight {
    line-height: 4rem !important;
    @media (max-width: 959px) {
        line-height: 2.75rem !important;
    }
}
</style>
